export type Vector2 = readonly [number, number];

export interface WordRect {
  readonly x: Vector2;
  readonly y: Vector2;
}

export interface Dimension2d {
  width: number;
  height: number;
}

export const pointRect = (point: Vector2): WordRect => ({
  x: [point[0], point[0]],
  y: [point[1], point[1]],
});

export enum LineOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
